import { createContext, useContext, useRef } from 'react';
import ToasterContainer, { DEFAULT_TOASTER, ToasterContainerRef } from './ToasterContainer';

const ToasterContext = createContext<React.RefObject<ToasterContainerRef>>({ current: DEFAULT_TOASTER });

export const ToasterContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const toasterRef = useRef<ToasterContainerRef>(DEFAULT_TOASTER);

  return (
    <ToasterContext.Provider value={toasterRef}>
      {children}
      <ToasterContainer ref={toasterRef} />
    </ToasterContext.Provider>
  );
};

export const useToaster = () => useContext(ToasterContext);
